export const mapFieldTypeOptionsValue: Record<string, string> = {
  "093bdd03-1dcb-4f0c-b44a-6f78cbe16691": "texto",
  "1fda1cb9-6aed-45d3-a518-5cdb051ccf25": "lista",
  "234d101a-de4a-4fb5-b0c8-4eb3415d909a": "textoMultlinhas",
  "cf834122-eb8b-4360-a372-b7f86cd7035b": "data",
  "6c429eaa-7ad6-41e3-be70-b38809c83d87": "booleano",
};
